import { getLexiProVariant } from "./lexi-pro-split";
import logger from "./logger";

export const trackPageView = () => {
  if (window.fbq) {
    window.fbq("track", "PageView");
  }
};

export const trackMetaPurchase = ({ value, currency, productName, eventId }) => {
  if (typeof window === "undefined") return false;
  if (typeof window.fbq !== "function") {
    logger.warn("Meta Pixel not initialized, purchase not tracked");
    return false;
  }

  const storageKey = eventId ? `meta_purchase_${eventId}` : "meta_purchase";
  try {
    if (window.sessionStorage?.getItem(storageKey) === "1") {
      logger.log("Meta Purchase already tracked, skipping", { eventId });
      return false;
    }
  } catch (error) {
    logger.warn("Meta Purchase storage unavailable", { error });
  }

  // 1. Ensure VALUE is a numeric type (Number) and exactly 2 decimal places
  const numericValue = Number(parseFloat(value || 0).toFixed(2));

  // 2. Ensure CURRENCY is exactly 3 uppercase letters with no symbols/spaces
  const cleanCurrency = String(currency || "AUD")
    .toUpperCase()
    .replace(/[^A-Z]/g, "")
    .substring(0, 3);

  // 3. Final validation before tracking
  if (numericValue <= 0 || cleanCurrency.length !== 3) {
    logger.warn("Invalid Meta Purchase payload aborted:", { numericValue, cleanCurrency });
    return false;
  }

  const payload = {
    value: numericValue,
    currency: cleanCurrency,
    content_name: productName,
    content_type: "product",
    contents: [
      {
        id: productName,
        quantity: 1,
      },
    ],
  };

  // Which half of the /lexi-pro split this sale came through, if any
  const lexiProVariant = getLexiProVariant();
  if (lexiProVariant) {
    payload.lexi_pro_variant = lexiProVariant;
  }

  const options = eventId ? { eventID: eventId } : undefined;
  window.fbq("track", "Purchase", payload, options);

  try {
    window.sessionStorage?.setItem(storageKey, "1");
  } catch (error) {
    logger.warn("Meta Purchase storage write failed", { error });
  }
  return true;
};

export const trackCompleteRegistration = () => {
  if (window.fbq) {
    window.fbq("track", "CompleteRegistration");
  }
};

export const trackViewContent = (param = {}) => {
  if (window.fbq) {
    window.fbq("track", "ViewContent", param);
  }
};
